import { SplashScreen } from "@capacitor/splash-screen";
import { useEffect } from "react";
import { useLoggedIn } from "@hooks/auth/useLoggedIn";
import DataController from "@controllers/DataController";
import { NavigationBar } from "@hugotomazi/capacitor-navigation-bar";
import { Capacitor } from "@capacitor/core";

export const useSplashScreen = () => {
  const loggedIn = useLoggedIn();

  useEffect(() => {
    const hideSplashScreen = async (): Promise<void> => {
      try {
        SplashScreen.hide();
      } catch (error) {
        console.log(error);
      }

      if (loggedIn) {
        if (!(await DataController.isWebAsync()) && Capacitor.getPlatform() === "android") {
          try {
            NavigationBar.setColor({ color: "#F7FAF8" });
          } catch (error) {
            console.log(error);
          }
        }
      }
    };

    hideSplashScreen();
  }, [loggedIn]);
};
